// extracted by mini-css-extract-plugin
export default {"container":"ResultModifier_container__0j2ai","item":"ResultModifier_item__6nP+2","count":"ResultModifier_count__ml4m9"};